export class PaymentSearchModel {
  public refferenceNo: number;
  public paymentCategory: string;
  public invoiceNo: string;
  public invoiceDate: Date;
  public recieptNo: string;
  public recieptDate: Date;
  public totalAmount: number;
  public idCardType: string;
  public paymentStatus: string;
}
